import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=2230fc9c&scoped=true&"
import script from "./attention.vue?vue&type=script&lang=js&"
export * from "./attention.vue?vue&type=script&lang=js&"
import style0 from "./attention.vue?vue&type=style&index=0&id=2230fc9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230fc9c",
  null
  
)

export default component.exports